const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_VENDOR_LIST': {
      return {
        ...state,
        vendorList: action.data,
      };
    }
    case 'SET_CURRENCY_LIST': {
      return {
        ...state,
        currencyList: action.data,
      };
    }
    case 'SET_INVOICE_DETAILS': {
      return {
        ...state,
        invoiceDetails: action.data.object_data
          ? { ...action.data.object_data }
          : { ...action.data },
        workflowDetails: action.promptError
          ? state.workflowDetails
          : action.data.object_data
          ? { ...action.data }
          : {},
        invoicePromptError: action.promptError || '',
        billsUrl: [],
        invoiceSubmitConfirmation: false,
        ocrError: false
      };
    }
    case 'INVOICE_SUBMIT_CONFIRMATION': {
      return {
        ...state,
        invoiceSubmitConfirmation: action.data,
        invoicePromptError: '',
      };
    }
    case 'SET_INVOICE_PROMPT_ERROR': {
      return {
        ...state,
        invoicePromptError: '',
      };
    }
    case 'SET_WORKFLOW_COMMENT': {
      return {
        ...state,
        comment: action.data,
      };
    }
    case 'UPDATE_FILES': {
      return {
        ...state,
        billsUrl: action.files,
        ocrError: action.deletedFileIndex === 0 ? '' : state.ocrError || '',
      };
    }

    case 'RESCHEDULE_CANCEL_SUCCESS': {
      return {
        ...state,
        [`${action.successType}Success`]: action.value,
      };
    }
    case 'SET_DATA': {
      const { deletedFileIndex, s3Data } = action;
      return {
        ...state,
        ocrError:
          deletedFileIndex == 0
            ? action.ocrError
            : state.ocrError || action.ocrError || '',
        ocrData: action.ocrData,
        updateCount: (state.updateCount || 0) + 1,
        billsUrl: deletedFileIndex
          ? [...state.billsUrl].filter((f, i) => i !== +deletedFileIndex)
          : [
              ...(state.billsUrl || []),
              ...(s3Data?.bill_urls || [])?.reverse(),
            ] || [],
      };
    }
    case 'INVOICE_BULK_SUCCESS': {
      return {
        ...state,
        invoiceBulkSuccess: action.data
      }
    }
    default: {
      return state;
    }
  }
};

export default reducer;
